const venueBlocks = document.querySelectorAll('.venue');
const disabledRoomClass = 'v-room--disabled';

function filterVenue(value, block) {
  const venues = block.querySelectorAll('.v-room');

  venues.forEach((venue) => {
    if (venue.dataset.venue !== value && value !== '0') {
      venue.classList.add(disabledRoomClass);
    } else if (venue.classList.contains(disabledRoomClass)) {
      venue.classList.remove(disabledRoomClass);
    }
  });
}
venueBlocks.forEach((block) => {
  const select = block.querySelector('[data-menu-select]');

  if (select) {
    let activeValueSelect = select.value;

    select.addEventListener('change', () => {
      const newActiveValue = select.value;

      if (newActiveValue !== activeValueSelect) {
        filterVenue(newActiveValue, block);
      }

      activeValueSelect = newActiveValue;
    });
  }
});
